import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import FiscalYearList from './FiscalYearList';
import { icon } from 'leaflet';

const Periods = () => {
	const breadcrumbLinks = [
		{ to: '/#', label: 'Inicio', icon: 'icon-house' },
		{ to: '/#', label: 'Abastecimiento', icon: 'icon-shopping-basket' },
		{ to: '/#', label: 'Configuración', icon: 'icon-settings' }
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Períodos' links={breadcrumbLinks} icon={'icon-calendar-days'} />
					<FiscalYearList />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Periods;
